/** Pricing groups whose resources count as used by the platform, not sold. */
export const INTERNAL_PRICING_GROUPS: readonly string[] = ['fluence', 'admin']

export function isInternalPricingGroup(group: string): boolean {
  return INTERNAL_PRICING_GROUPS.includes(group)
}
